import { render, staticRenderFns } from "./Clarify.vue?vue&type=template&id=96fbaf8a&scoped=true&"
import script from "./Clarify.vue?vue&type=script&lang=js&"
export * from "./Clarify.vue?vue&type=script&lang=js&"
import style0 from "./Clarify.vue?vue&type=style&index=0&id=96fbaf8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fbaf8a",
  null
  
)

export default component.exports